import { instance } from '@/services/avik-api-gateway'
import { GraphData } from '@/composable/useGraph'

export function getMainGraphTrainSearch(params: {
  departureDate: string
  trainId: string
}): Promise<GraphData[]> {
  return instance
    .get<(GraphData & { otn: string })[]>(`/graph/main-graph`, {
      params: {
        ...params,
        version: 2,
      },
    })
    .then<GraphData[]>((res) => {
      return res.data.map((x) => ({
        ...x,
        otn: parseInt(x.otn, 10),
      }))
    })
}

export function getMainGraphPlaceSearch(params: {
  timeFrom: string
  timeTo: string
  places: string[]
}): Promise<GraphData[]> {
  return instance
    .get<GraphData[]>(`/graph/place-search/main-graph`, {
      params: {
        ...params,
        places: params.places.join(','),
      },
    })
    .then<GraphData[]>((res) => {
      return res.data
    })
}
